import { euCountries } from '../constants/euCountries'

/** Whether a visitor's country requires prior consent before third-party tracking (EU27 + GB). */
export const isEuCountry = (countryCode: string): boolean => euCountries.includes(countryCode)
